import { Pipe, PipeTransform } from '@angular/core';
import {
  LOCALE_CODE_LIST,
  Language,
  NOT_AVAILABLE,
  TIME_12HOUR_FORMAT,
  TIME_SHORT_FORMAT,
  LOCALE_SHORT_DISPLAY_DATE_FORMAT,
} from '../constants';
import { getHoursOffsetFromString, getTimestampWithTimezoneOffset } from '../utils';
import { AppFacade, AuthFacade } from '../../store';
import { Subscription, filter, take } from 'rxjs';
import moment from 'moment';

@Pipe({
  name: 'toLocalOffset',
})
export class ToLocalOffsetPipe implements PipeTransform {
  private localeValue: string;
  private timeFormat: string;
  private dateFormat: string;
  private subscription: Subscription[] = [];

  constructor(private authFacade: AuthFacade, private appFacade: AppFacade) {
    this.subscription.push(
      this.appFacade.currentLanguage$.pipe(filter(Boolean)).subscribe((language: Language) => {
        this.localeValue = LOCALE_CODE_LIST[language];
      }),
      this.authFacade.isTwentyFourHourTime$.pipe(take(1)).subscribe((isTwentyFourHourTime: boolean) => {
        this.timeFormat = isTwentyFourHourTime ? TIME_SHORT_FORMAT : TIME_12HOUR_FORMAT;
        this.dateFormat = `${LOCALE_SHORT_DISPLAY_DATE_FORMAT} ${this.timeFormat}`;
      }),
    );
  }

  transform(
    timestamp: number,
    offset: string,
    dateFormat: string = this.dateFormat,
    emptyPlaceholder: string = NOT_AVAILABLE,
  ): string {
    if (!timestamp) {
      return emptyPlaceholder;
    }

    const calculatedOffset = getHoursOffsetFromString(offset);

    return moment(getTimestampWithTimezoneOffset(timestamp, -calculatedOffset))
      .locale(this.localeValue)
      .format(dateFormat);
  }
}
